import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import API from '../../utils/api';
import states from "../../utils/states.js";
import { getCurrentOrg } from "../../utils/operations.js";
import { observer, inject } from "mobx-react";
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';

const NewOrganisations = ({ Auth, history }) => {
  if (!Auth.can('organisations')) { history.push("/children"); return null; }
  const [data, setData] = useState({
    name: "", address: "", city: "", st: "", zip: "", phone: "", fax: "",
    site: "http://www.stepstosuccess.com/", email: "", taxid: "",
    stripe_account: "", stripe_publishable_key: "", stripe_secret_key: "", stripe_webhook_secret: "",
  });
  const handleChange = ({ target: { id, value } }) => setData(prev => ({ ...prev, [id]: value }));

  const saveData = async () => {
    try {
      await API.post(getCurrentOrg, { resource: [data] });
      toast.success('Organization added successfully!');
      Auth.getAllOrgs();
      setTimeout(() => history.push("/organisations"), 1000);
    } catch {
      toast.error('Something went wrong!');
    }
  };

  return (
    <div style={{ maxWidth: 500, margin: "auto" }}>
      <h3>School</h3>
      <TextField id="name" label="School Name" fullWidth value={data.name} onChange={handleChange} sx={{ mb: 2 }} />
      <TextField id="address" label="Address" fullWidth value={data.address} onChange={handleChange} sx={{ mb: 2 }} />
      <TextField id="city" label="City" fullWidth value={data.city} onChange={handleChange} sx={{ mb: 2 }} />
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel id="state-label">State</InputLabel>
        <Select labelId="state-label" value={data.st || ''} label="State" onChange={({ target: { value } }) => setData(prev => ({ ...prev, st: value }))}>
          {states.map((row, index) => <MenuItem key={index} value={row}>{row}</MenuItem>)}
        </Select>
      </FormControl>
      <TextField id="zip" label="ZIP" fullWidth value={data.zip} onChange={handleChange} sx={{ mb: 2 }} />
      <InputMask mask="999-999-9999 ext. 999" value={data.phone} onChange={handleChange} disabled={false}>
        {(inputProps) => <TextField {...inputProps} id="phone" label="Phone" fullWidth sx={{ mb: 2 }} />}
      </InputMask>
      <TextField id="fax" label="Fax" fullWidth value={data.fax} onChange={handleChange} sx={{ mb: 2 }} />
      <TextField id="site" label="Website" fullWidth value={data.site} onChange={handleChange} sx={{ mb: 2 }} />
      <TextField id="email" label="Email" fullWidth value={data.email} onChange={handleChange} sx={{ mb: 2 }} />
      <TextField id="taxid" label="Tax ID#" fullWidth value={data.taxid} onChange={handleChange} sx={{ mb: 2 }} />
      <br />
      <h3>Stripe Integration</h3>
      <TextField id="stripe_account" label="Stripe Account" fullWidth value={data.stripe_account} onChange={handleChange} sx={{ mb: 2 }} />
      <TextField id="stripe_publishable_key" label="Stripe Publishable KEY" fullWidth value={data.stripe_publishable_key} onChange={handleChange} sx={{ mb: 2 }} />
      <TextField id="stripe_secret_key" label="Stripe Secret KEY" fullWidth value={data.stripe_secret_key} onChange={handleChange} sx={{ mb: 2 }} />
      <TextField id="stripe_webhook_secret" label="Stripe WebHook Secret" fullWidth value={data.stripe_webhook_secret} onChange={handleChange} sx={{ mb: 2 }} />
      <div style={{ display: "flex", gap: 10, alignItems: "center", justifyContent: "center", paddingTop: 20, paddingBottom: 20 }}>
        <Button variant="contained" color="primary" onClick={saveData}>Save</Button>
        <Button variant="contained" color="secondary" onClick={() => history.push("/organisations")}>Cancel</Button>
      </div>
    </div>
  );
};

export default inject("Auth")(observer(NewOrganisations));

